/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioServicingRoleType } from './PortfolioServicingRoleType';
import {
    PortfolioServicingRoleTypeFromJSON,
    PortfolioServicingRoleTypeFromJSONTyped,
    PortfolioServicingRoleTypeToJSON,
    PortfolioServicingRoleTypeToJSONTyped,
} from './PortfolioServicingRoleType';

/**
 * Optional servicing role for one portfolio. On update, omitting the object leaves the stored role. An empty object clears it.
 * 
 * @export
 * @interface PortfolioServicingRole
 */
export interface PortfolioServicingRole {
    /**
     * 
     * @type {PortfolioServicingRoleType}
     * @memberof PortfolioServicingRole
     */
    servicingRoleType?: PortfolioServicingRoleType;
    /**
     * Employee user id.
     * @type {string}
     * @memberof PortfolioServicingRole
     */
    servicingUser?: string;
    /**
     * Read-only employee display name for servicingUser. Ignored on create and update.
     * 
     * @type {string}
     * @memberof PortfolioServicingRole
     */
    servicingUserName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioServicingRole
     */
    modifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioServicingRole
     */
    modifiedBy?: string;
}



/**
 * Check if a given object implements the PortfolioServicingRole interface.
 */
export function instanceOfPortfolioServicingRole(value: object): value is PortfolioServicingRole {
    return true;
}

export function PortfolioServicingRoleFromJSON(json: any): PortfolioServicingRole {
    return PortfolioServicingRoleFromJSONTyped(json, false);
}

export function PortfolioServicingRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioServicingRole {
    if (json == null) {
        return json;
    }
    return {
        
        'servicingRoleType': json['servicingRoleType'] == null ? undefined : PortfolioServicingRoleTypeFromJSON(json['servicingRoleType']),
        'servicingUser': json['servicingUser'] == null ? undefined : json['servicingUser'],
        'servicingUserName': json['servicingUserName'] == null ? undefined : json['servicingUserName'],
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
        'modifiedBy': json['modifiedBy'] == null ? undefined : json['modifiedBy'],
    };
}

export function PortfolioServicingRoleToJSON(json: any): PortfolioServicingRole {
    return PortfolioServicingRoleToJSONTyped(json, false);
}

export function PortfolioServicingRoleToJSONTyped(value?: PortfolioServicingRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'servicingRoleType': PortfolioServicingRoleTypeToJSON(value['servicingRoleType']),
        'servicingUser': value['servicingUser'],
        'servicingUserName': value['servicingUserName'],
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
        'modifiedBy': value['modifiedBy'],
    };
}

